export default __webpack_public_path__ + "static/media/onion.abdfcfd0.jpeg";